import React from 'react';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import SEO from "../../../utils/SEO";

export default function RealEstateInvestmentSpain() {

    return (
        <main className='main'>
            <SEO
                title="Spain Real Estate Investment | Golden Visa Residency"
                description="Invest in Spanish real estate and secure EU residency through the Golden Visa program with €500,000 minimum investment and strong returns."
                keywords="Spain real estate investment, Spain Golden Visa, EU residency Spain, property investment Spain, €500000 visa Spain, Spain property investors, residency by investment Spain, buy property Spain"
                url="/real-estate-investment-spain"
            />
            <IntroSection
                title="Real Estate Investment in Spain"
                subtitle="Secure EU Residency & Golden Visa Through Property"
                description="Spain is one of Europe’s top destinations for property investors and families seeking residency. Through the Golden Visa program, investors obtain long-term EU residency by purchasing qualifying real estate—while benefiting from rental yields, property appreciation, and Spain’s exceptional lifestyle."
                badges={[
                    "Golden Visa Residency",
                    "€500,000 Minimum Investment",
                    "EU Market Access"
                ]}
                buttonText="Request a Spain Real Estate Consultation →"
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/real-estate/real-estate-investment-spain-hero.png')}
                imageAlt="Spain Real Estate Investment"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Invest in Spain Real Estate?"
                        blocks={[
                            {
                                items: [
                                    { title: "Golden Visa Pathway", text: "Obtain residency with a €500,000 property purchase." },
                                    { title: "Strong Market Growth", text: "High demand in major cities and coastal regions." },
                                    { title: "Rental Yields", text: "Excellent returns in Barcelona, Madrid, Marbella, and Valencia." },
                                    { title: "Lifestyle & Quality of Life", text: "Mediterranean climate, healthcare, education, safety." },
                                    { title: "EU Residency", text: "Freedom to travel across 27 Schengen countries." },
                                    { title: "Tax Optimization", text: "Combine property investment with Spain’s Beckham Law expat tax regime." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Golden Visa via Real Estate"
                        blocks={[
                            {
                                items: [
                                    { text: "Minimum Investment: €500,000 (residential, commercial, or land)." },
                                    { text: "Residency Validity: 2-year permit, renewable in 5-year intervals." },
                                    { text: "Eligible Family Members: spouse, children under 21, dependent parents." },
                                    { text: "Benefits: live, work, study in Spain; travel freely in Schengen; no minimum stay requirement." },
                                    { text: "Citizenship Path: 10 years of residence (reduced to 2 years for Ibero-American nationals)." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Best Areas for Real Estate Investment"
                        blocks={[
                            {
                                items: [
                                    { text: "Madrid – business hub, cultural center, strong rental returns." },
                                    { text: "Barcelona – international hotspot, high demand for urban living." },
                                    { text: "Costa del Sol (Marbella, Malaga) – luxury villas, resort lifestyle." },
                                    { text: "Valencia – affordable and growing digital nomad destination." },
                                    { text: "Balearic Islands (Ibiza, Mallorca) – premium holiday homes." },
                                    { text: "Canary Islands – strong tourism market and lower living costs." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Investment Models"
                        services={[
                            { title: "Residential Homes & Apartments", text: "Suitable for personal use or long-term rentals." },
                            { title: "Holiday Rentals", text: "High returns through vacation platforms like Airbnb." },
                            { title: "Commercial Properties", text: "Offices, retail spaces, hotels, and income-producing assets." },
                            { title: "Mixed-Use Developments", text: "Modern projects combining living, retail, and hospitality." }
                        ]}
                    />

                    <WhySection
                        title="Advantages of Spain Real Estate Residency"
                        blocks={[
                            {
                                items: [
                                    { title: "EU Residency with Family Inclusion", text: "Include your spouse, children, and dependent parents." },
                                    { title: "No Stay Requirement", text: "Maintain residency without needing to relocate full-time." },
                                    { title: "Secure Investment", text: "Protected by strong property laws and transparent processes." },
                                    { title: "Rental Income & Capital Growth", text: "Benefit from dual returns through appreciation and yields." },
                                    { title: "Tax Planning Benefits", text: "Use Spain’s Beckham Law to optimize your tax residency." }
                                ]
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>


                    <CTA
                        title="Ready to invest in Spain real estate and secure EU residency?"
                        description="Offshore Advisory provides property investment guidance, Golden Visa support, and tax structuring advice under the Beckham Law."
                        buttonText="Book a Spain Real Estate Consultation Today →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};


const faqData = [
    {
        question: "What is the minimum real estate investment for Spain residency?",
        content: [
            { type: "answer", text: "€500,000." }
        ],
    },
    {
        question: "Can I combine multiple properties to meet the threshold?",
        content: [
            { type: "answer", text: "Yes, as long as the total is €500,000 or more." }
        ],
    },
    {
        question: "Does Spain allow dual citizenship?",
        content: [
            { type: "answer", text: "Only for Ibero-American and select countries. For others, citizenship requires renunciation." }
        ],
    },
    {
        question: "Can I rent out my investment property?",
        content: [
            { type: "answer", text: "Yes, both long-term and short-term rentals are permitted." }
        ],
    },
    {
        question: "How long does it take to get residency approval?",
        content: [
            { type: "answer", text: "2–4 months." }
        ],
    },
];
